/**
 * Episode Presentational Component
 * View: Displays an episode
 */

require('../styles/credits.scss');
const CMFLogo = require('../images/CMF_logo.svg');
const APFCLogo = require('../images/APFC_Logo.svg');
const balestraLogo = require('../images/logoBalestra_transparent.png');
const unisLogo = require('../images/unis_logo_black.svg');
const canadaLogo = require('../images/canada_logo.svg');
const OMDCLogo = require('../images/OMDCLogo.svg');

import React from 'react';
import store from '../store';
import actions from '../actions/episodeActions';

class Credits extends React.Component {

  componentWillMount(){
    store.dispatch(actions.EPISODE_UPDATE_CURRENT(null));
  }

  render(){
    return (
      <div className="credits">
        <h1 className="title">CRÉDITS</h1>

        <div className="guide">
          <div className="credits__column-left">
            <h2>GUIDE D’AVENTURES SAISON 2 – SÉRIE TÉLÉVISUELLE</h2>
            {/* NOTE: Mettre le logo de la signature télé GUIDE d'AVENTURES (à venir dans le Google Drive GUIDE DU GUIDE-PRODUCTION / LOGO) */}
            <div className="credit"><span className="label">Producteur</span> Mark Chatel</div>
            <div className="credit"><span className="label">Scénariste</span> Jean-François Martel, Olivier Pinsonneault </div>
            <div className="credit"><span className="label">Recherchistes</span> Carole Gaulin, Jean-Marc Pacelli</div>
            <div className="credit"><span className="label">Réalisateur-Coordonnateur</span> Mark Chatel</div>
            <div className="credit"><span className="label">Réalisateurs</span> Isabelle Major, Jean-François Martel</div>
            <div className="credit"><span className="label">Narratrice</span> Micheline Marchildon</div>
            <div className="credit"><span className="label">Directrice de production</span> Nancy Boucher</div>
            <div className="credit"><span className="label">Coordonnateur de production</span> Alain Lauzon</div>
            <div className="credit"><span className="label">Assistante de production</span> Sarah Séguin</div>
            <div className="credit"><span className="label">Directeur de la photographie</span> Ivan Cooke</div>
            <div className="credit"><span className="label">Caméras supplémentaires</span> Matt Maddaloni, Isabelle Major</div>
            <div className="credit"><span className="label">Preneurs de son</span> Jon Lebrun, Maxime Forgues</div>
            <div className="credit"><span className="label">Monteurs</span> Yves Soglo, Isabelle Major</div>
            <div className="credit"><span className="label">Assistants au montage</span> Maxime Forgues, Anik Gauthier, Félix-Antoine Janelle</div>
            <div className="credit"><span className="label">Superviseure de postproduction</span> Nancy Boucher</div>
            <div className="credit"><span className="label">Monteur en ligne</span> Harry Ferderber</div>
            <div className="credit"><span className="label">Musiques originales</span> Michel Demars</div>
            <div className="credit"><span className="label">Musiques additionnelles</span> Firstcom Music, Ole Production Music</div>
            <div className="credit"><span className="label">Infographie</span> Chakib Bouayed</div>
            <div className="credit"><span className="label">Mixage et mastering audio</span> Jean-François Robert</div>
            <div className="credit"><span className="label">Comptables</span> Claudine Bazinet, Joey Charest, Marcil Lavallée</div>
            <div className="credit"><span className="label">Archives visuelles</span> Radio-Canada</div>
            <div className="credit"><span className="label">Remerciements</span> Centre Kanatha-Aki, Chilcotin Holidays, Killarney Outfitters, Mountain Skills Academy & Adventures, Ontario Ministry of Natural Ressources and Forestry, Ontario Parks - Sleeping Giant Provincial Park, T'Ashii Paddle School, Tofino Volunteer Fire Department, Tuff City Radio </div>
            <div className="credit"><span className="label">Produit par</span> Balestra Productions inc.<img src={balestraLogo} width="180px" /></div> {/* Mettre le logo de Balestra Production: https://drive.google.com/file/d/0BxpILAwF2AS3cGtNOTU3Ry05LTQ/view?usp=sharing */}
            <div className="credit"><span className="label">Produit avec une collaboration de</span> Unis tv
            <img src={unisLogo} title="UNIS Logo" width="180px" color="#a7b814" /></div> 	{/* Mettre le logo de UNIS: https://drive.google.com/drive/folders/0BxpILAwF2AS3OG5JYzNBWUVTYzA wwww.unis.ca mettre cette mention sous le logo de UNIS */}
            <div className="credit"><span className="label">Chef des productions originales</span> Séverine Biderman</div>
            <div className="credit"><span className="label">Directeur de la programmation</span> Pierre Gang</div>
            <div className="credit">
              <span className="label">FONDS DES MÉDIA DU CANADA</span>
              <img src={CMFLogo}  width="180px" />
            </div> {/* Mettre le Logo de FMC : https://drive.google.com/file/d/0BxpILAwF2AS3NWZKWjE3bjlKUTg/view?usp=sharing */}
            <div className="credit">
              <span className="label">Avec l’assistance du gouvernement de l’Ontario. Crédit d’impôt pour production cinématographique et télévisuelle ontarienne</span>
              <img src={OMDCLogo}  height="110px" />
            </div>{/* Mettre le logo ONTARIO : https://drive.google.com/drive/folders/0BxpILAwF2AS3OG5JYzNBWUVTYzA */}
            <div className="credit">
              <span className="label">Avec la participation du Crédit d’impôt pour production cinématographique ou magnétoscopique canadienne</span>
              <img src={canadaLogo}  width="180px" />
            </div> {/*MOT SYMBOLE CANADA : https://drive.google.com/open?id=0Bw4DQQ1zR2YYc1k0Q2hPRzNrRW8 */}
            <div className="credit">
              <span className="label">Financement intérimaire de la Banque Nationale du Canada - Groupe Cinéma et Télévision</span>
              <img src={APFCLogo}  width="180px" />
            </div>
          </div>

          <div className="credits__column-right">
            <h2>SUIVEZ LE GUIDE SAISON 2 - VOLET MÉDIA NUMÉRIQUE</h2>
            {/* NOTE: mettre le logo de la si  SUIVEZ LE GUIDE */}
            <div className="credit"><span className="label">Produit en collaboration avec</span> Unis tv
            <img src={unisLogo} title="UNIS Logo"  width="180px" height="60.7px" color="#a7b814" /></div>
            <div className="credit"><span className="label">Directeur, Contenus Numérique</span>Benoit Beaudoin</div>
            <div className="credit"><span className="label">Chef de productions, contenus numériques</span> Daniel Angers</div>
            <div className="credit"><span className="label">Agente de projets, contenus numériques</span> Juliane Choinière</div>
            <div className="credit"><span className="label">Et avec la participation de</span> Fonds des médias du Canada<img src={CMFLogo} width="180px" /></div>
            <div className="credit"><span className="label">Produit par</span> Balestra interactif inc.<img src={balestraLogo} height="110px" /></div>
            <div className="credit"><span className="label">Producteur Média Numérique</span> François Tessier</div>
            <div className="credit"><span className="label">Scénariste</span> Jean-Marc Pacelli</div>
            <div className="credit"><span className="label">Montage Vidéo</span> Vincent Chenier</div>
            <div className="credit"><span className="label">Superviseur de la post-production</span> Anik Gauthier</div>
            <div className="credit"><span className="label">Infographie</span> Chakib Bouayed, Patrick Racine</div>
            <div className="credit"><span className="label">Réalisation</span> LVL Studio <a href="http://lvlstudio.com/fr" target="lvlstudio.com">
              <img src="http://lvlstudio.com/medias/header/logo.svg" alt="" height="50px" />
            </a></div>
            <div className="credit"><span className="label">Chef de projet</span> Grey Recanati</div>	{/* je suggère de mettre tous vos noms en majuscule pour concilier avec le reste des crédits */}
            <div className="credit"><span className="label">Directeur de création</span> Benoit Leclair</div>
            <div className="credit"><span className="label">Chef d’équipe conception</span> Aurélie Bosc</div>
            <div className="credit"><span className="label">Designer d’interaction</span> François Perrin</div>
            <div className="credit"><span className="label">Designers</span> Michel O'Narey, Rux Centea et David Blais</div>
            <div className="credit"><span className="label">Illustrateur</span> Michel Lebrun</div>
            <div className="credit"><span className="label">Programmeur</span> Jean-Sébastien Bélanger-Ricard</div>
            <div className="credit"><span className="label">Spécialiste assurance qualité</span> Jean-Philippe Noël</div>
            <div className="credit"><span className="label">Technicien intégration de système</span> Joe Di Lalla</div>

          </div>
        </div>
      </div>
    )
  }
}

export default Credits;



// WEBPACK FOOTER //
// ./src/components/Credits.js